<template>
  <div class="welcome-widget">
    <b-row class="text-center" align-v="center">
      <b-col>
        <h4>Enjoying Auroras.live?</h4>
        <p>Support Auroras.live on Patreon for exclusive features!</p>
        <div class="patreon-widget">
          <a class="patronButton" href="https://www.patreon.com/bePatron?u=15812619" data-patreon-widget-type="become-patron-button">Become a Patron!</a>
        </div>
      </b-col>
      <b-col>
        <h4>Take Auroras.live with you!</h4>
        <p>Download the apps for push notifications and more!</p>
        <div>
          <b-button variant="warning" pill href="https://app.auroras.live"><cellphone-arrow-down-icon /> Get the App!</b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import CellphoneArrowDownIcon from "vue-material-design-icons/CellphoneArrowDown.vue"

export default {
  name: 'Welcome',
  components: {
    CellphoneArrowDownIcon
  }
}
</script>

<style scoped>
  .patreon-widget {
    width: 178px !important;
    margin: 0 auto;
  }
</style>
